import styles from "./BackgroundSection.module.css";
import Betreuung from "../assets/Icons/Icons_Benefit_Betreuung.svg";
import Kommunikation from "../assets/Icons/Icons_Benefit_Kommunikation.svg";
import Loesungen from "../assets/Icons/Icons_Benefit_Loesungen.svg";
import Produktentwicklung from "../assets/Icons/Icons_Benefit_Produktentwicklung.svg";
import Produktion from "../assets/Icons/Icons_Benefit_Produktion.svg";
import Prozesse from "../assets/Icons/Icons_Benefit_Prozesse.svg";
import WhiteLabel from "../assets/Icons/Icons_Benefit_whiteLabel.svg";

export default function BackgroundSection({ src, alt, height = "1000px" }) {
  return (
    <section className={styles.backgroundSection} style={{ minHeight: height }}>
      <img className={styles.backgroundImage} src={src} alt={alt} />

      <div className={styles.overlay} />

      <div className={styles.content}>
        <div className={styles.list}>
          <ListItem
            Icon={Loesungen}
            text="MASSGESCHNEIDERTE LÖSUNGEN AUS STAHL"
          />
          <ListItem
            Icon={Produktentwicklung}
            text="ERSTKLASSIGE PRODUKTENTWICKLUNG"
          />
          <ListItem Icon={WhiteLabel} text="WHITE-LABEL-PRODUKTE" />
          <ListItem Icon={Produktion} text="PRODUKTION IN DER EU" />
          <ListItem
            Icon={Betreuung}
            text="PERSÖNLICHE HOCHPROFESSIONELLE BETREUUNG"
          />
          <ListItem Icon={Prozesse} text="EINFACHE DIGITALE PROZESSE" />
          <ListItem Icon={Kommunikation} text="UNKOMPLIZIERTE KOMMUNIKATION" />
        </div>
      </div>
    </section>
  );
}

function ListItem({ text, Icon }) {
  return (
    <div className={styles.listItem}>
      <img src={Icon} alt="" className={styles.icon} />
      <p className={styles.listItemText}>{text}</p>
    </div>
  );
}
